/**
 * The Help section's tab row: Platform map, Navigation & tabs, Guided tour and
 * Who uses what, in the demo's `HELP_TABS` order (demo line 3720), plus the
 * fork's Structure tab (the platform as a numbered outline) beside the map.
 *
 * The demo rendered the four as tabs on one page. Here each is its own route,
 * so the row navigates rather than swapping state, and a deep link to any tab
 * still works. Guided tour sits at the bare `/help`, which is where
 * `routeForView('help', 'tour')` already points.
 *
 * Presentation only; it goes in each help scene's `SurfacePageHeader` `tabs`
 * slot.
 */

import { useNavigate } from 'react-router-dom';
import { SurfacePageTabs } from '@/design-system';

export type HelpTabId = 'map' | 'structure' | 'nav' | 'tour' | 'roles';

const HELP_TABS: readonly { id: HelpTabId; label: string; to: string }[] = [
  { id: 'map', label: 'Platform map', to: '/help/platform-map' },
  // fork(oem/v1.8): the WBS outline — Jay's "is there a mind-map of all the sections?"
  { id: 'structure', label: 'Structure', to: '/help/structure' },
  { id: 'nav', label: 'Navigation & tabs', to: '/help/navigation' },
  { id: 'tour', label: 'Guided tour', to: '/help' },
  { id: 'roles', label: 'Who uses what', to: '/help/roles' },
];

export function HelpTabs({ current }: { current: HelpTabId }) {
  const navigate = useNavigate();

  return (
    <SurfacePageTabs
      aria-label="Help pages"
      items={HELP_TABS}
      value={current}
      onChange={(id) => {
        const tab = HELP_TABS.find((t) => t.id === id);
        if (tab) navigate(tab.to);
      }}
    />
  );
}
